import React, { useEffect } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { ReactComponent as InfoIcon } from "../../../../assets/TryMyPriceInfo.svg";
import ToggleCheckbox from "shared/ui/toggle-checkbox";
import Equals from "../../../../assets/Equals.svg";
import { GetCurrByCode } from "helpers/currencies";

type PropsType = {
  sellCurrencySymbol: string;
  buyCurrencySymbol: string;
  marketPrice: number | string;
  value: number | null;
  setValue: (val: number | null) => void;
  onInfoClick: () => void;
  bid?: number;
  ask?: number;
  onValidationChange?: (isInvalid: boolean, tryMyPrice: boolean) => void;
  specialOffer?: {
    from: string;
    to: string;
    price: number;
    timeLeft: string;
  };
};

const PriceCard: React.FC<PropsType> = ({
  sellCurrencySymbol,
  buyCurrencySymbol,
  marketPrice,
  value,
  setValue,
  onInfoClick,
  bid,
  ask,
  onValidationChange,
  specialOffer,
}) => {
  const { t } = useTranslation("app");

  const tryMyPrice = value !== null;

  const isInvalid =
    tryMyPrice &&
    value !== null &&
    bid &&
    ask &&
    (value === 0 || isNaN(value) || +value < +bid || +value > +ask);

  useEffect(() => {
    if (onValidationChange) {
      onValidationChange(!!isInvalid, tryMyPrice);
    }
  }, [isInvalid, tryMyPrice, onValidationChange]);

  return (
    <div className="currencies-limit-price-card">
      <div
        className={
          specialOffer
            ? "currencies-limit-price-card__price-row-special-offer"
            : "currencies-limit-price-card__price-row"
        }
      >
        <p>{t("Market price")}</p>
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <p>1{sellCurrencySymbol}</p>
          <p> = </p>
          <p>
            {marketPrice}
            {buyCurrencySymbol}
          </p>
        </div>
      </div>

      {specialOffer && (
        <div className="currencies-limit-price-card__price-row">
          <p>
            {t("specialPrice")} <span>{specialOffer.timeLeft}</span>
          </p>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <p>1{GetCurrByCode(specialOffer.from)?.symbol}</p>
            <p> = </p>
            <p>
              {+specialOffer.price.toFixed(4)}
              {GetCurrByCode(specialOffer.to)?.symbol}
            </p>
          </div>
        </div>
      )}

      <hr />

      <div className="currencies-limit-price-card__try-row">
        <p>{t("tryMyPrice")}</p>

        <InfoIcon onClick={onInfoClick} aria-label={t("info")} role="button" />

        <ToggleCheckbox
          className="try-my-price-toggle"
          checked={tryMyPrice && !specialOffer}
          onChange={(checked) => setValue(checked ? 0 : null)}
        />
      </div>

      {!specialOffer && tryMyPrice && (
        <div className="currencies-limit-price-card__inputs-row">
          <div className="currencies-limit-price-card__inputs-row__left">
            1{sellCurrencySymbol}
          </div>

          <img src={Equals} alt="equals" />

          <input
            autoFocus
            type="number"
            value={isNaN(value || 0) ? "" : value || ""}
            min={0}
            onChange={(e) => {
              const val = e.target.value;
              setValue(Number(val));
            }}
            className="currency-card__amount-input"
            style={{ background: "#fbfbfb" }}
          />
          <span className="currencies-limit-price-card__inputs-row__symbol">
            {buyCurrencySymbol}
          </span>
        </div>
      )}

      {!specialOffer && isInvalid && value > 0 && (
        <span className="currencies-limit-price-card__inputs-row__error">
          {t("enterMarketPrice")} {bid} / {ask}
        </span>
      )}
    </div>
  );
};

export default PriceCard;
